"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdatePayData = void 0;
const luxon_1 = require("luxon");
const react_query_1 = require("react-query");
const fetchClient_1 = require("../../client/fetchClient");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const paths_1 = require("../../paths");
function useUpdatePayData({ employeeId, timeZone, shouldFetch, usageLocation }) {
    const { host, clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const { data, isLoading, error, mutate } = (0, react_query_1.useMutation)((0, fetchClient_1.submitData)(currentStage));
    if (!shouldFetch) {
        return undefined;
    }
    const updatePayData = (payDataItems) => {
        mutate({
            path: (0, paths_1.UPDATE_PAY_DATA_API)(employeeId),
            method: 'PUT',
            body: {
                payDataItems,
                requester: employeeId,
                submitDateTime: luxon_1.DateTime.now().setZone(timeZone).toString()
            },
            host,
            metaData: {
                apiName: 'udpatePayData',
                clientName
            },
            usageLocation
        });
    };
    return {
        updatePayDataState: {
            data: data,
            isLoading,
            error
        },
        updatePayData
    };
}
exports.useUpdatePayData = useUpdatePayData;
